<template lang="pug">
v-app
  header.d-flex.row.flex-row.align-items-end.mb-3
    .col-12
      h2.m-0
        i Confirmacion de Procesos Mensual
  section
    .d-flex.row.flex-row.align-items-start.mt-4
        .col-12.col-lg-6
          .card.p-0.ad_border1-primaryLight.rounded-xl
            .card-body
              .row
                .col-12.py-2.rounded-lg.ad_bg-gray.mb-3

                  form
                    .form-group.row
                      .col-12
                        label.pl-0.m-0 Libre
                        input.form-checkbox.text-none(type="checkbox", id="open", label="", :value="open" v-model="openSelected", @change='disableRegObjec($event)')
                    .form-group.row
                      .col-12
                        multiselect(
                          v-model="selectedColaborador",
                          :options="team",                
                          :multiple="true",
                          :close-on-select="true",
                          :clear-on-select="false",
                          :preserve-search="true",
                          placeholder="Selecciona Colaboradores",
                          label="name",
                          track-by="_id")
                    .form-group.row.mt-3
                      .col-12
                        multiselect(
                          v-model="selectedObjetivo",
                          :options="currentWeekObjectives",                
                          :multiple="true",
                          :close-on-select="true",
                          :clear-on-select="false",
                          :preserve-search="true",
                          placeholder="Seleccione objetivos",
                          :custom-label="customLabel",
                          track-by="_id",
                          :disabled='openSelected'
                        )                
                          template(slot="option", slot-scope="props")
                            .col.pr-0(:title="`${props.option.travel ? props.option.travel.name : ''}/${props.option.product ? props.option.product.name : ''}/${props.option.segment ? props.option.segment.name : ''}/${props.option.business_type ? props.option.business_type.name: ''}`")
                              span {{props.option.name ? props.option.name : 'Sin Kpi'}}
                            .col.pr-0(:title="`${props.option.travel ? props.option.travel.name : ''}/${props.option.product ? props.option.product.name : ''}/${props.option.segment ? props.option.segment.name : ''}/${props.option.business_type ? props.option.business_type.name: ''}`")
                              i.icon-letters.icon-letters__viaje.mr-1(v-if="props.option.travel") V
                              i.icon-letters.icon-letters__producto.mr-1(v-if="props.option.product") P
                              i.icon-letters.icon-letters__segmento.mr-1(v-if="props.option.segment") S
                              i.icon-letters.icon-letters__negocio.mr-1 N
                    .form-group.row.mt-3
                      .col-auto.pl-0.pr-2
                        i.icon-letters.icon-letters__producto.mr-1 R
                      .col.px-0.ad_select(:class='{disabled : !openSelected}')
                        select(v-model="selectedRole", @change='getSelectedTriplets($event)', :disabled='!openSelected')
                          option(:value="null" disabled) Selecciona Rol
                          option(:value="role", v-for="role in userRoles", :key="role._id") {{role.name}}
                    .form-group.row.mt-3
                      .col-auto.pl-0.pr-2
                        i.icon-letters.icon-letters__negocio.mr-1 N
                      .d-flex.col.p-0
                        .ad_select(:class='{disabled : !openSelected}')
                          select(v-model='selectedKpiNegocio', :disabled='(!selectedRole && openSelected)|| !openSelected')
                            option(:value="null" disabled) Selecciona KPI Negocio
                            option(:value="business" v-for="business in businesstypes" :key="business._id") {{business.name}}
                    .form-group.row.mt-3
                      .col-auto.pl-0.pr-2
                        i.icon-letters.icon-letters__kpi.mr-1 A
                      .d-flex.col.p-0
                        .ad_select(:class='{disabled : (!selectedKpiNegocio && openSelected) || !openSelected}')
                          select(v-model='selectedKpiAdherencia' :disabled='!selectedKpiNegocio && !openSelected')
                            option(:value="null" disabled) Selecciona KPI Adherencia
                            option(:value="kpi" v-for="kpi in kpis" :key="kpi._id") {{kpi.name}}
                      .d-flex.col-auto.pr-0.d-flex.align-self-stretch
                        .d-flex.ad_text-grayMedio.text-center.w-100
                          .input-refresh.d-flex.flex-row.align-items-center.ml-2(:class='{disabled : (!selectedKpiNegocio && openSelected) || !openSelected}')
                            input(type="text" value="" v-model="registroAdherencia" maxlength="3" :disabled='!selectedKpiNegocio && !openSelected')
                            | %
                            a#kpiadherencia(href="#")
                              i.fas.fa-info-circle.ad_text-secondary.ml-1
                            b-tooltip(target="kpiadherencia" , placement='top')
                              | % de cumplimiento del KPI de Adherencia que se espera alcanzar en la semana
                    .form-group.row.align-items-center
                      .col-auto.pl-0.pr-1
                        i.icono.icono-comentarios.ad_text-primary
                      .col.px-0
                        textarea.form-control(id='comm', placeholder='Comentarios (opcional)', rows='3', v-model="comment", :disabled='!openSelected')
                    .form-group.row.mt-3
                      .col-6.position-relative
                        v-menu(ref='menu', v-model='menu', :close-on-content-click='true', :nudge-right='40', lazy, transition='scale-transition', offset-y, full-width, min-width='290px', content-class='date-picker')
                          v-text-field.date-input.pt-0.mt-0(slot='activator', v-model='date', label='', placeholder='Fecha', append-icon='fas fa-calendar-alt')
                          v-date-picker(v-model='date', no-title, locale="es", :min="startWeek", :max="endWeek", @input="menu2 = false", next-icon='fas fa-chevron-right', prev-icon='fas fa-chevron-left', :first-day-of-week="1")
                      .col-6.d-flex.justify-content-end
                        button.btn.btn-secondary.btn__large(:class='{disabled : validateForm ? false : true}' @click="create()")
                          | Agregar
                          i.fas.fa-plus.border.border-white.rounded-circle.p-1.ml-2               
        .col-12.col-lg-6
          .card.p-0.ad_border1-primaryLight.rounded-xl
            .card-body
              h3.mb-3.ad_text-primary
                i CP Mensuales
              .card.pt-4.px-3.ad_border1-secondaryLight.rounded-xl(v-for="(cp, i) in tracings")
                .row.d-flex.mb-3.align-items-end
                  .d-flex.col
                    span.text-muted {{ cp.users[0].name }}
                  .d-flex.col-auto
                    span.h4.mr-3.mb-0
                      | {{ moment(cp.date).utc().format("DD/MM/YYYY") }}
                    router-link.btn.btn-secondary.px-3(:to="{name: 'CP Mensual Ejecutar', params: { id:cp._id } }")
                      | Ejecutar
                    .col-4.d-flex.justify-content-between
                      button.btn-icon.p-0.ad_text-danger.border-btnicon-danger.rounded-circle(@click="closeMCP(cp._id)" :id="'eliminamcp' + i")
                        i.fas.fa-times.p-0
                      b-tooltip(:target="'eliminamcp' + i" , placement='top')
                        | Eliminar CP Mensual

                .col-12.py-2.rounded-lg.ad_bg-gray.mb-3
                  .d-flex.row
                    .col-12
                      table.w-100.table-rounded-body
                        thead
                          tr
                            th(colspan="6") Objetivos
                        tbody
                          tr(v-for="obj in cp.objectives" :key="obj.id")
                            td.py-1
                              div
                                i.icon-letters.icon-letters__viaje.mr-1(v-if="obj.travel") V
                                | {{obj.travel ? obj.travel.name : ' '}}
                            td.py-1
                              div
                                i.icon-letters.icon-letters__producto.mr-1(v-if="obj.product") P
                                | {{obj.product ? obj.product.name : ' '}}
                            td.py-1
                              div
                                i.icon-letters.icon-letters__segmento.mr-1(v-if="obj.segment") S
                                | {{obj.segment ? obj.segment.name : ' '}}
                            td.py-1
                              div
                                i.icon-letters.icon-letters__negocio.mr-1 N
                                | {{obj.business_type ? obj.business_type.name: ' '}}
                            td.py-1
                              div
                                i.icon-letters.icon-letters__kpi.mr-1(v-if="obj.kpi") A
                                | {{obj.kpi ? obj.kpi.name : ''}}
                            td.py-1.text-right
  
    section
      .d-flex.row.flex-row.mt-4
        .col-12
          .card.p-0.ad_border1-primaryLight.rounded-xl
            .card-body
              h4.mb-3.ad_text-primary
                i Historial
              .row.flex-row.d-none
                .col-10
                  .row
                    .form-group.col-4
                      .ad_select
                        select(v-model='selected')
                          option(:value="null" disabled) Campo de selección
                          option(:value="dummy.value" v-for="dummy in dummys") {{dummy.value}}
                    .form-group.col-4
                      .ad_select
                        select(v-model='selected')
                          option(:value="null" disabled) Campo de selección
                          option(:value="dummy.value" v-for="dummy in dummys") {{dummy.value}}
                    .form-group.col-4
                      input.form-control(type="text" placeholder="Campo de texto")
                .col-10
                  .row
                    .form-group.col-4
                      .ad_select
                        select(v-model='selected')
                          option(:value="null" disabled) Campo de selección
                          option(:value="dummy.value" v-for="dummy in dummys") {{dummy.value}}
                    .form-group.col-4
                      .ad_select
                        select(v-model='selected')
                          option(:value="null" disabled) Campo de selección
                          option(:value="dummy.value" v-for="dummy in dummys") {{dummy.value}}
                    .form-group.col-4
                      input.form-control(type="text" placeholder="Campo de texto")
                .col-2
                  button.btn.btn__medium.btn-secondary(@click.prevent='loadListHistory')
                    | Aplicar

              .row.mt-3(v-show="historial")
                .col-12
                  b-table.w-100.text-center.table-simple(
                    show-empty
                    stacked="md"
                    :items='listHistory',
                    :fields="fields",
                    :sort-compare= "dateSorter",
                    :current-page="0",
                    :sort-by="sortBy",
                    :sort-desc="sortDesc",
                    :per-page="perPage")
                    template(slot='view', slot-scope='row')
                      router-link(:to="{path:'/confirmacion-procesos-mensual/'+row.item.id+'/detail'}" append)
                        i.icono.icono-ver.ad_text-primary.align-top
                  b-pagination(
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  @input="selectedPage()"
                  class="my-0")

    v-navigation-drawer(v-model='drawer', app='', temporary='', right='', width='500')
      header.ad_bg-primary.pt-5.pb-2.px-4
        h3.text-white.mt-4
          i Comentarios
      section.py-4.px-2.overflowy-auto
        .col.d-flex.flex-nowrap
          label
            p.icon-letters.icon-letters__viaje.mr-1 Via
            | Viaje
          label.ml-3
            p.icon-letters.icon-letters__kpi.mr-1 Kpi
            | KPI de Negocio 1
        .row.align-items-end
          .col
            .col-12
              h4 KPI Adherencia
          .col-auto.pr-5
            p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
              sup Registro
              span.ad_text-grayDark 60%
            p.d-inline-block.mb-0.ad_text-grayMedio
              sup Meta
              span 90%
      .flex-row
        .col-12.mt-4
          .form-group.mt-4
            textarea.form-control(placeholder='Agregar comentario' rows='3')
          .form-group.justify-content-between
            button.btn.btn-grayLight-border.py-2.pl-2.pr-3.font-1em(@click="drawer = false")
              i.far.fa-times-circle.fa-1x.mr-1.align-bottom
              | Cancelar
            button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="moveobjetivo = true; drawer = false;")
              | Agregar comentario
              i.fas.fa-plus-circle.fa-1x.ml-1.align-bottom
          
          hr.my-4
          
          h3.ad_text-grayMedio.mb-3
            i Anteriores
          div(v-if="tracing")        
            .row.mb-3(v-for='comm in tracing.comments')
              .col-4.pr-0
                p.font-weight-bold.m-0 {{comm.user}}
                small.d-block {{comm.date | DateFormat}}
                small.d-block {{comm.date | HourFormat}} hrs.
              .col-8.pl-0
                .dialog-box
                  p {{comm.text}}  

</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment';

export default {
  name: 'ConfirmacionProcesosMHome',
  components: {},
  data() {
    return {
      sortBy: "executionDate",
      sortDesc: true,
      comment: null,
      historial: true,
      selected: null,
      drawer: false,
      comments: null,
      list: null,
      tracing: null,
      listHistory: null,
      dummys: [
        { value: "Demo 1", label: "Demo 1" },
        { value: "Demo 2", label: "Demo 2" },
        { value: "Demo 3", label: "Demo 3" }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      totalPages: 0,
      fields: [
        { key: 'executionDate', label: 'Ejecucion', sortable: true, sortDirection: 'desc', class: 'text-center'},
        { key: 'collaborator', label: 'Colaborador', sortable: true, class: 'text-left'},
        { key: 'mandated', label: 'Encargado', sortable: true, class: 'text-left'},
        { key: 'objectivesCount', label: 'Obj.', sortable: true, class: 'text-center'},
        { key: 'personalCommitmentsCount', label: 'Comp. Personales' , sortable: true, class: 'text-center'},
        { key: 'leaderCommitmentsCount', label: 'Comp. Líder' , sortable: true, class: 'text-center'},
        { key: 'opportunitiesProblemsCount', label: 'Prob/Oport' , sortable: true, class: 'text-center'},
        { key: 'view', label: 'Ver' , class: 'text-center'}
      ],
      currentWeekObjectives: [],
      selectedObjetivo: null,
      selectedColaborador: null,
      selectedKpiNegocio: null,
      selectedKpiAdherencia: null,
      registroAdherencia: 0,
      team: [],
      tracings: [],
      kpis: [],
      businesstypes: [],
      date: null,
      user: {},
      menu: false,
      startWeek: moment().startOf('month').utc().subtract(1, "days").toISOString(),
      endWeek: moment().endOf("month").utc().subtract(1, "days").toISOString(),
      openSelected: false,
      open: false,
      selectedRole: null,
      userRoles: []
    };
  },
  methods: {
    moment,
    ...mapActions('monthlypc', ['getByCreator', 'getByCreatorHistory', 'createMPC', 'closeTracing']),
    ...mapActions('plan', ['planByWeek']),
    ...mapActions('user', [
      'myTeam'    
    ]),
    ...mapActions('objective', [
      'getObjByPlanForList', 'addObjCPM'
    ]),
    ...mapActions('businesstype', [
      'businessSelectList', 'businessBySegTraProd'
    ]),
    ...mapActions('kpi', [
      'kpiSelectList', 'kpiBySegTraProRole', 'kpiByIds'
    ]),
    ...mapActions('role', [
      'byTriplets', 'roleByIds'
    ]),
    dateSorter(a, b, key) {
      if (key !== "executionDate") {
        return null; // or false
      }
      let aDate = moment(a[key], "DD/MM/YYYY");
      let bDate = moment(b[key], "DD/MM/YYYY");
      if (aDate.isValid && bDate.isValid) {
        if (aDate < bDate) {
          return -1;
        } else if (aDate > bDate) {
          return 1;
        } else {
          return 0;
        }
      }
      return null;
    },
    finishCreation(newObj) {
      const vm = this;
      const loading = vm.$toast.loading('Creando...');
      let currentWeek = moment().isoWeek();
      // const type = vm.user.profile.auth.tabs.indexOf("confirmacion_procesos") != -1 ? 'CP' : 'SD';
      let mpc = {
        name: `C.P Mensual ${currentWeek}`,
        date: vm.date,
        objectives: vm.selectedObjetivo,
        users: vm.selectedColaborador,
        user_leader: vm.user.id,
        plan: vm.plan._id
      }

      if (newObj) {
        mpc.objectives = newObj._id;
      }      
      
      vm.createMPC(mpc).then((tracing) => {
               
        vm.tracings.push(tracing);     
        vm._clearForm();       
        loading.hide();
        vm.$notify({
          type: 'success',
          title: 'Notificación',
          content: 'C.P./S.D creado',
          closeable: true,
          duration: 5000
        })
      }, (error) => {
        loading.hide();
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error,
          closeable: true,
          duration: 5000
        })
      });
    },
    create() {
      const vm = this
      let newObj = null;
      
      if (vm.user.profile.leader_leaders && vm.user.profile.suggested_mcp > 0) {
        if ( (vm.tracings.length < vm.user.profile.suggested_mcp) || (vm.tracings.length == vm.user.profile.suggested_mcp && vm.openSelected) ) {
          if ( !vm.validateForm() ) {
            vm.$notify({
              type: 'danger',
              title: 'Notificación',
              content: "Porfavor rellene todos los campos",
              closeable: true,
              duration: 5000
            })
          } else {
            if (vm.openSelected) {
              const loading = vm.$toast.loading('Creando Objetivo Libre...');
              let comments = []
              if (vm.comment) {
                comments.push({
                  user: vm.user.name,
                  date: moment(),
                  text: vm.comment
                })
              }
              vm.addObjCPM({
                date: vm.date,
                business_type: vm.selectedKpiNegocio,
                kpi: vm.selectedKpiAdherencia,
                kpipercentage: vm.registroAdherencia,
                user: vm.selectedColaborador,
                created_by: vm.user.id,
                plan: vm.plan,
                open: vm.openSelected,
                comments: comments,
                ica: 60,
                businesspercentage: 0
              }).then((newObj) => {
                vm.finishCreation(newObj);
                loading.hide();
                vm.$notify({
                  type: 'success',
                  title: 'Notificación',
                  content: 'Objetivo creado',
                  closeable: true,
                  duration: 5000
                });
              }, (error) => {
                loading.hide();
                vm.$notify({
                  type: 'danger',
                  title: 'Notificación',
                  content: error,
                  closeable: true,
                  duration: 5000
                });
              });
            } else {
              vm.finishCreation(newObj);
            }
          }
        } else {
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: `No puede tener mas de ${vm.user.profile.suggested_mcp} CP Mensual`,
            closeable: true,
            duration: 5000
          });
        }
      } else {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: `Su configuracion actualmente es ${vm.user.profile.suggested_mcp} CP Mensuales`,
          closeable: true,
          duration: 5000
        });
      }
    },
    listing() {
      const vm = this
      const loading = vm.$toast.loading('Cargando CP...')
      const id = vm.$store.state.auth.user.id
        
      const data = {
        userid: vm.user.id
      }
      vm.getByCreator(data).then(response => {
        vm.tracings = response
        loading.hide()
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      }).catch(err => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'No existe plan para esta semana',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    },
    openObjDetail(id) {
      const vm = this      
      vm.getTracingById(id).then(() => {        
        vm.tracing = vm.$store.getters['tracingById/getComments']   
        vm.tracing.comments = vm.tracing.comments.reverse()     
        vm.drawer = !vm.drawer
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    },
     commentsByCP() {
      const vm = this
      vm.commentsById(id).then(() => {
        vm.comments = vm.$store.getters['commentsById/getComments']
        vm.comments = vm.comments.reverse()
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error,
          closeable: true,
          duration: 5000
        })
      })
    },
    addCommentToCP(id) {
      const vm = this
      if (vm.comment === null) {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: 'Porfavor agregue una descripcion al comentario',
          closeable: true,
          duration: 5000
        })
      } else {
        let comm = {
          user: vm.user.name,
          date: moment(),
          text: vm.comment
        }
        vm.addComment({
          id: id,
          comment: comm  
        }).then(() => {
          vm.objective.comments.push(comm)
          vm.objective.comments = vm.objective.comments.reverse()
          vm.comment = null
          vm.drawer = false        
        }, (error) => {
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: error.payload.message,
            closeable: true,
            duration: 5000
          })
        })
      }
    },
    loadListHistory() {
      const vm = this;
      const loading = vm.$toast.loading("Cargando Histórico CPs...");
      const data = {
        userId: vm.$store.state.auth.user.id,
        type: 'CP',
        pagination: {page: vm.currentPage, perPage: vm.perPage}
      }
      vm.getByCreatorHistory(data).then((response) => {
        vm.listHistory = response.docs;
        vm.totalRows = response.total;
        vm.currentPage = response.page
        loading.hide()
      }, (error) => {
        vm.$notify({
          type: "danger",
          title: "Notificación",
          content: error.payload.message,
          closeable: true,
          duration: 5000
        });
      })
    },
    selectedPage() {
      const vm = this;
      vm.loadListHistory();
    },
    customLabel: function(value){
      return `${value.name}`;
    },
    _clearForm() {
      const vm = this;
      vm.selectedColaborador = null;
      vm.selectedObjetivo = null;
      vm.selectedRole = null;
      vm.selectedKpiNegocio = null;
      vm.selectedKpiAdherencia = null;
      vm.registroAdherencia = 0;
      vm.openSelected = false;
      vm.date = null;
      vm.comment = null;
    },
    closeMCP(id) {
      const vm = this;
      vm.closeTracing(id).then((resp) => {
        for (let index in vm.tracings) {
          if (vm.tracings[index]._id == id) {
            vm.tracings.splice(index, 1)
          }                  
        }        
        vm.$notify({
          type: 'success',
          title: 'Notificación',
          content: 'CP Mensual cerrado',
          closeable: true,
          duration: 5000
        });
      }, (error) => {
        vm.$notify({
          type: "danger",
          title: "Notificación",
          content: error.payload.message,
          closeable: true,
          duration: 5000
        });
      });
    },
    disableRegObjec($event) {
      const vm = this;
      if (vm.openSelected) {
        vm.selectedObjetivo = null;
      }
    },
    getBusinessTypes($event) {
      const vm = this;
      vm.businessBySegTraProd({
        segment: vm.openSelected ? vm.selectedRole.triplets[0].segment : vm.selectedSegmento._id, 
        travel: vm.openSelected ? vm.selectedRole.triplets[0].travel : vm.selectedViaje._id,
        product: vm.openSelected ? vm.selectedRole.triplets[0].product : vm.selectedProducto._id 
      }).then((response) => {
        vm.businesstypes = response;
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      });
    },
    getKpis($event) {
      const vm = this;
      vm.kpiSelectList().then((response) => {
        vm.kpis = response;
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      });
    },
    validateForm() {
      const vm = this;
      let isValid = true;

      if (!vm.openSelected) {
        if ( vm.selectedColaborador === null || vm.selectedObjetivo === null || vm.date === null || vm.selectedColaborador.length === 0 ) {
          isValid = false;
        }
      } else {
        if ( vm.selectedColaborador === null || vm.date === null || vm.selectedColaborador.length === 0 || vm.selectedRole === null || vm.openSelected == null) {
          isValid = false;
        }
      }

      return isValid;
    },
    getSelectedTriplets($event) {
      const vm = this
      // if (!vm.openSelected) {
        vm.selectedViaje = vm.selectedRole.triplets[0].travel
        vm.selectedSegmento = vm.selectedRole.triplets[0].segment
        vm.selectedProducto = vm.selectedRole.triplets[0].product
      // } else {
      //   vm.selectedViaje = null
      //   vm.selectedSegmento = null
      //   vm.selectedProducto = null
      // }
      vm.getKpisByIds()
      vm.getBusinessTypes()
    },
    getKpisByIds($event) {
      const vm = this
      const loading = vm.$toast.loading('Cargando kpis de adherencia...')
      vm.byTriplets({
        travel: vm.openSelected ? vm.selectedRole.triplets[0].travel : vm.selectedViaje._id, 
        segment: vm.openSelected ? vm.selectedRole.triplets[0].segment : vm.selectedSegmento._id, 
        product: vm.openSelected ? vm.selectedRole.triplets[0].product : vm.selectedProducto._id
      }).then((roles) => {
        //filtrar por role de usuarios.
        let rolesFiltered = []
        let rolesForFilter = vm.selectedRole ? [vm.selectedRole._id] : vm.user.role
        if (roles.length > 0) { 
          for (let r of roles) {
            for (let ur of rolesForFilter) {
              if (r._id.toString() == ur) {
                rolesFiltered.push(r)
              }
            }
          }
        }
        if (rolesFiltered.length > 0) {
          vm.kpiByIds({ role: rolesFiltered }).then(() => {
            vm.kpis = vm.$store.getters['kpi/getKpis']
          }, (error) => {
            vm.$notify({
              type: 'danger',
              title: 'Notificación',
              content: error,
              closeable: true,
              duration: 5000
            })
          })
        } else {
          vm.kpis = []
        }
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error,
          closeable: true,
          duration: 5000
        })
      })
      loading.hide()
    },
    getUserRoles() {
      const vm = this;
      vm.roleByIds({ids: vm.user.role}).then(() => {
        vm.userRoles = vm.$store.getters['role/getRoles']
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    }
  },
  watch: {
    moveobjetivo: function() {
      let moveobjetivo = this.moveobjetivo;
      if (this.moveobjetivo === true) {
        this.$emit("can-continue", { value: true });
        this.$emit("completed-step", { value: true });
      } else {
        this.$emit("can-continue", { value: false });
      }
    },
    drawer: function() {
      this.$parent.overlay = !this.$parent.overlay;
      this.$emit("clase", this.$parent.overlay);
      const el = document.querySelector(".overlay");

      if (this.$parent.overlay) {
        el.classList.add("open");
      } else {
        el.classList.remove("open");
      }
    }
  },
  mounted() {
    const vm = this
    vm.user = vm.$store.getters['auth/getUserInfo'] 
    vm.plan = vm.$store.getters['plan/getPlan'];
    vm.team = vm.$store.getters['user/getMyTeam'];
    
    let idplan = vm.plan ? vm.plan._id : null;
    if (idplan) {
      // vm.getBusinessTypes();
      // vm.getKpis();
      vm.getUserRoles();
      vm.myTeam(vm.user.id).then(() => {
        vm.getObjByPlanForList(idplan).then(() => {
          vm.currentWeekObjectives = vm.$store.getters['objective/getObjectives']
          if (vm.currentWeekObjectives.length > 0) {
            for (var objective of vm.currentWeekObjectives) {
              objective.name = objective.kpi.name
            }
          }
        }, (error) => {
          loading.hide()
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: error.payload.message,
            closeable: true,
            duration: 5000
          });
        });
      }, (error) => {
        loadingc.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        });
      });
    } else {
      vm.$notify({
        type: 'danger',
        title: 'Notificación',
        content: 'Debe iniciar el proceso de planificacion para poder comenzar',
        closeable: true,
        duration: 5000
      });
    }
    vm.listing();
    vm.loadListHistory();
  }
};
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/views/cpmensual/cp-mensual-home.vue